// ─── A lesson's name in the panel ─────────────────────────────────────────────
//
// Teaching is monolingual since 2026-10-13: a lesson is authored with an
// English title only and its Persian title is stored empty. Older lessons
// still carry one, shown beside the name rather than instead of it.

/** The name to show: the English title, or the Persian one for a lesson that somehow lacks it. */
export function lessonName(lesson) {
  return lesson?.titleEn?.trim() || lesson?.titleFa?.trim() || '—'
}

/** An older lesson's Persian title, when it has one that says something else; '' otherwise. */
export function lessonAltName(lesson) {
  const fa = lesson?.titleFa?.trim()
  return fa && fa !== lessonName(lesson) ? fa : ''
}
